<template>
  <div class="emptyContainer">
    <img class="emptyState" v-if="!emptyWeetUrl"
         :style="$listeners.click?'cursor:pointer':''" width="90"
         @click="$listeners.click?onClick():null" alt="emptyState" src="@/assets/weet_light.png"/>
    <div v-else>
      <ExternalWeetPlayer :url="emptyWeetUrl"/>
    </div>
    <div class="titleEmptyState" :style="$listeners.click?'cursor:pointer':''" @click="$listeners.click?onClick():null">
      {{ this.title }}
    </div>
    <div class="subtitle" v-html="this.subtitle" :style="$listeners.click?'cursor:pointer':''"
         @click="$listeners.click?onClick():null">
    </div>
    <div class="slotEmpty">
      <slot></slot>
    </div>
  </div>
</template>

<script lang="ts">
import {Component, Prop, Vue} from 'vue-property-decorator';
import ExternalWeetPlayer from '@/components/play/player/modal/ExternalWeetPlayer.vue';

@Component(
    {
      name: 'EmptyState',
      components: {ExternalWeetPlayer},
    })
export default class EmptyState extends Vue {
  @Prop({default: ''})
  private title!: string;
  @Prop({default: ''})
  private subtitle!: string;

  @Prop({default: ''})
  private emptyWeetUrl!: string;

  private onClick() {
    this.$emit('click');
  }

}
</script>
<style lang="scss">
.tipsLabel {
  .primary {
    cursor: pointer;
    color: var(--primary);
  }
}
</style>

<style scoped lang="scss">
@import "@/scss/gridBreakPoint.scss";

.emptyContainer {
  width: 100%;
  height: 100%;

  .emptyState {
    margin-top: 0px;
    max-height: 250px;
  }

  .titleEmptyState {
    font-size: 24px;
    font-weight: 900;
    max-width: 600px;
    color: var(--black);
    margin: auto;
    margin-top: 0px;

  }

  .subtitle {
    margin: auto;
    margin-top: 8px;
    margin-bottom: 8px;
    color: var(--light2);
    font-size: 14px;
    max-width: 450px;
    font-weight: 600;
  }

  .tipsLabel {
    margin: auto;
    margin-top: 8px;
    margin-bottom: 8px;
    color: var(--light2);
    font-size: 14px;
    max-width: 450px;
    font-weight: 600;
  }

  .slotEmpty {
    margin-top: 40px;
  }
}

</style>
